import type { ReactNode } from "react";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

export default function PageHeader({ title, subtitle, children }: PageHeaderProps) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-6">
      <div className="flex-1 min-w-0">
        <h1 className="text-h4 md:text-h3 font-bold text-foreground-900 font-heading">{title}</h1>
        {subtitle && (
          <p className="text-sm text-foreground-500 mt-1 max-w-3xl">{subtitle}</p>
        )}
      </div>
      {children && (
        <div className="flex items-center gap-2 flex-wrap">
          {children}
        </div>
      )}
    </div>
  );
}